import React, { CSSProperties, FC } from "react";
import classNames from "classnames";
import { View } from "@tarojs/components";
import { pxTransform } from "@/utils";
import type { StandardLonghandProperties } from "csstype";
import { XHComponentCommonProps } from "../../types";
import "./index.scss";

export type LoadingProps = {
  style?: CSSProperties & {
    "--loading-border-color"?: StandardLonghandProperties["color"];
    "--loading-border-width"?: string;
  };
  size?: number;
} & XHComponentCommonProps;

const Activityindicator: FC<LoadingProps> = ({
  className,
  style,
  size = 36,
  ...rest
}) => {
  const cls = classNames("xh-activity-indicator", className);

  let finalStyle = {
    ...style,
    ...rest,
  };
  if (size !== 36) {
    finalStyle = {
      ...finalStyle,
      width: pxTransform(size),
      height: pxTransform(size),
    };
  }

  return (
    <View className={cls} style={finalStyle}>
      <View className="xh-activity-indicator-main"></View>
      <View className="xh-activity-indicator-main"></View>
      <View className="xh-activity-indicator-main"></View>
    </View>
  );
};

export default Activityindicator;
